import { lazyNamed } from 'src/utils/lazyNamed';

export const Calendars = {
  List: lazyNamed(() => import('./containers/CalendarsList'), 'CalendarsList'),
  Form: lazyNamed(() => import('./containers/CalendarForm'), 'CalendarForm'),
};
